export default {
  name: 'World Strategic Forum',
  shortName: 'Miami',
  description:
    'The World Strategic Forum was created in 2011 and is held annually in Miami, Florida, where it welcomes attendees from all over the world. The WSF brings together decision makers from all spheres of society to tackle the most pressing issues of our time.',
  thumbnail: '/images/events/miami/thumbnail-miami.jpg',
  link: 'https://www.worldstrategicforum.com/',
  header: {
    content:
      'The World Strategic Forum was created in 2011 and is held annually in Miami, Florida, where it welcomes attendees from all over the world. The WSF brings together decision makers from all spheres of society to tackle the most pressing issues of our time.'
  },
  bullets: {
    bullet1: {
      number: '12th',
      label: 'Edition'
    },
    bullet2: {
      number: '1 000+',
      label: 'In-Person Participants'
    },
    bullet3: {
      number: '70+',
      label: 'Speakers'
    },
    bullet4: {
      number: '35+',
      label: 'Represented Countries'
    }
  },
  about: {
    title: 'Our Purpose',
    content:
      'The mission of the World Strategic Forum is to address today’s major corporate and governance challenges, while fostering a better understanding of the opportunities and challenges at stake for the Americas within the Global market. The central themes of the WSF revolve around the Global Economy, Finance, Tech, Trade, Energy, Infrastructure, Investment and Legacy Planning.'
  },
  next: {
    title: 'Mastering The New Economy',
    content:
      "The world is changing at pace, resulting in a number of emerging trends and breakthroughs, as well as many challenges. This year’s edition of the WSF will examine the ways in which we can innovate, adapt and succeed within the new global economy. Join us for insightful discussion, thought-provoking luncheons and invaluable networking receptions from November 6th-7th as we convene international thought leaders and decision makers to discuss 'Mastering the New Economy'."
  },
  gallery: {
    title: 'Photo gallery',
    index: [
      {
        title: '11th edition — Investing in Trust',
        images: [
          '/images/events/miami/gallery/11th-miami-001.jpg',
          '/images/events/miami/gallery/11th-miami-002.jpg',
          '/images/events/miami/gallery/11th-miami-003.jpg',
          '/images/events/miami/gallery/11th-miami-004.jpg',
          '/images/events/miami/gallery/11th-miami-005.jpg',
          '/images/events/miami/gallery/11th-miami-006.jpg',
          '/images/events/miami/gallery/11th-miami-007.jpg',
          '/images/events/miami/gallery/11th-miami-008.jpg',
          '/images/events/miami/gallery/11th-miami-009.jpg',
          '/images/events/miami/gallery/11th-miami-010.jpg',
          '/images/events/miami/gallery/11th-miami-011.jpg',
          '/images/events/miami/gallery/11th-miami-012.jpg',
          '/images/events/miami/gallery/11th-miami-013.jpg',
          '/images/events/miami/gallery/11th-miami-014.jpg',
          '/images/events/miami/gallery/11th-miami-015.jpg',
          '/images/events/miami/gallery/11th-miami-016.jpg',
          '/images/events/miami/gallery/11th-miami-017.jpg',
          '/images/events/miami/gallery/11th-miami-018.jpg',
          '/images/events/miami/gallery/11th-miami-019.jpg',
          '/images/events/miami/gallery/11th-miami-020.jpg',
          '/images/events/miami/gallery/11th-miami-021.jpg'
        ]
      }
    ]
  }
}
